'use client';
import React, { useEffect } from 'react';

const KekaJobs = () => {

   
  useEffect(() => {
    // 1. Set global config on window
    window.khConfig = {
      identifier: '25b7d15a-ce1c-439d-a49f-be822c46b54e',
      domain: 'https://medhavi.keka.com/careers/',
      targetContainer: '#khembedjobs',
    };

    // 2. Inject the external script
    const script = document.createElement('script');
    script.src =
      'https://medhavi.keka.com/careers/api/embedjobs/js/25b7d15a-ce1c-439d-a49f-be822c46b54e';
    script.defer = true;

    document.body.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto my-[30px] md:my-[60px] lg:my-[80px]">
      <div className="container mx-auto text-left mb-[12px] md:mb-[20px]">
            <h2 className="mb-[12px] tracking-[-1.2px] text-centre section-title ">Our Current Openings</h2>
            <p className="text-[black] leading-[23px] text-centre mb-[30px] md:mb-[48px]">
             Our working community creates the ideal atmosphere for career growth and personal expression.
            </p>
          </div>
      <div id="khembedjobs" />
    </div>
  );
};

export default KekaJobs;
